<div class="iam-topbar">
  <div class="iam-topbar-left">
    <div class="p-pt-1 p-pl-3">
      <a routerLink="/personal-income-tax/tax-deduction" title="TTC">
        <img src="assets/ttc-invoice/TTC-invoice.png" alt="TTC Invoice" style="height: 4rem">
      </a>
    </div>
  </div>
  <div class="iam-topbar-right">
    <div class="iam-topbar-menu" *ngIf="AuthService.hasRoles(['Customer'])">
      <a pRipple class="iam-topbar-app-link" [href]="invoiceUrl + '/customer/invoice/hdbh'">
        <img src="assets/icon-app-ttc/icon-app-ttc-invoice.png" alt="Hóa đơn điện tử">
        <span>HÓA ĐƠN<br>ĐIỆN TỬ</span>
      </a>
      <a pRipple class="iam-topbar-app-link" [href]="invoiceUrl + '/customer/invoice-sync'">
        <img src="assets/icon-app-ttc/icon-app-ttc-qlhd.png" alt="Quản lý hoá đơn đầu vào">
        <span>QUẢN LÝ HÓA ĐƠN ĐẦU VÀO</span>
      </a>
      <a pRipple class="iam-topbar-app-link" routerLink="/personal-income-tax/tax-deduction" routerLinkActive="active">
        <img src="assets/icon-app-ttc/icon-app-ttc-tncn.png" alt="Quản lý Chứng từ TNCN">
        <span>QUẢN LÝ CHỨNG TỪ TNCN</span>
      </a>
    </div>
    <ul class="iam-topbar-actions">
      <li class="iam-topbar-action">
        <a pRipple class="rounded-circle" (click)="entities.onTopbarActionClick($event, 'Profile')"
          title="{{ 'Profile'|translate }}">
          <ng-container *ngIf="!logoData">
            <i class="pi pi-user pi-large"></i>
          </ng-container>
          <ng-container *ngIf="logoData">
            <img [src]="logoData" alt="" style="border-radius: 50%; width: 40px; height: 40px;">
          </ng-container>
          <span class="p-ml-2" *ngIf="user">{{ displayName }}</span>
        </a>
        <ul *ngIf="entities.activeTopbarAction === 'Profile'" class="iam-topbar-action-panel p-shadow-6">
          <li class="layout-topbar-action-item">
            <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="changePassword()">
              <i class="pi pi-unlock p-mr-2"></i>
              <span>{{ 'ChangePassword'|translate }}</span>
            </a>
          </li>
          <li class="layout-topbar-action-item">
            <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="logout()">
              <i class="pi pi-power-off p-mr-2"></i>
              <span>{{ 'Logout'|translate }}</span>
            </a>
          </li>
          <li class="p-pt-2 p-pr-3 p-pl-3 p-text-center">
            <span style="font-size: 12px;color: #616161;">{{ user['partyName'] }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
  <p-dialog header="{{ 'ChangePassword'|translate }}" [(visible)]="changingPassword" [style]="{width: '500px'}"
    [resizable]="false" position="top">
    <p-message severity="info"
      text="Xin quý khách lưu ý, để đảm bảo an ninh tài khoản nên dùng một mật khẩu đầy đủ yếu tố sau: Sử dụng ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường và số."></p-message>
    <div class="p-fluid p-formgrid p-grid p-mt-2">
      <div class="p-field p-col-12">
        <label for="oldPassword">{{ 'Password'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="oldPassword" formControlName="oldPassword">
        <app-validator [control]="changePasswordForm.get('oldPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPassword">{{ 'NewPassword'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="newPassword" formControlName="newPassword">
        <app-validator [control]="changePasswordForm.get('newPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPasswordVerify">{{ 'NewPasswordVerify'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="newPasswordVerify" formControlName="newPasswordVerify">
        <app-validator [control]="changePasswordForm.get('newPasswordVerify')"></app-validator>
      </div>
    </div>
    <p-message severity="error" [text]="changePasswordError" *ngIf="changePasswordError"></p-message>
    <p-footer>
      <p-button label="{{ 'ChangePassword'|translate }}" icon="pi pi-check" styleClass="p-button-raised" type="submit"
        [disabled]="changePasswordForm.invalid"></p-button>
      <p-button label="{{ 'Close'|translate }}" icon="pi pi-times"
        styleClass="p-button-raised p-button-text p-button-plain" (onClick)="changingPassword=false"></p-button>
    </p-footer>
  </p-dialog>
</form>
